export const downloadFile = (args : string | {url: string, fileName?: string}): void => {
  const params = typeof args === 'string' ? { url: args } : args
  const { url, fileName } = params
  const a = document.createElement('a')
  a.href = url
  a.download = fileName || url
  // a.target = '_blank'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}